import { render } from "./SearchProduct.vue?vue&type=template&id=53094c5a&scoped=true"
import script from "./SearchProduct.vue?vue&type=script&lang=js"
export * from "./SearchProduct.vue?vue&type=script&lang=js"

import "./SearchProduct.vue?vue&type=style&index=0&id=53094c5a&land=css&lang=css"
import "./SearchProduct.vue?vue&type=style&index=1&id=53094c5a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53094c5a"]])

export default __exports__